import { createContext } from 'react';
export const AccountEditor = createContext({});
export var AccountDialogRoutes;
(function (AccountDialogRoutes) {
    AccountDialogRoutes["account"] = "account";
    AccountDialogRoutes["details"] = "details";
    AccountDialogRoutes["balance"] = "balance";
    AccountDialogRoutes["app_config"] = "app_config";
    AccountDialogRoutes["ui_config"] = "ui_config";
    AccountDialogRoutes["icons_settings"] = "icons_settings";
    AccountDialogRoutes["guest_mode"] = "guest_mode";
    AccountDialogRoutes["public_access"] = "public_access";
    AccountDialogRoutes["archive"] = "archive";
    AccountDialogRoutes["access_log"] = "access_log";
    AccountDialogRoutes["billing_history"] = "billing_history";
})(AccountDialogRoutes || (AccountDialogRoutes = {}));
